import React from 'react'

function DeleteBin(props) {
  const { disabled, onClick, style, ...rest } = props
  return (
    <svg
      width="58"
      height="57"
      viewBox="0 0 58 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : undefined,
        opacity: disabled ? 0.5 : 1,
        ...(style || {}),
      }}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      <g filter="url(#filter0_d_1_10020)">
        <rect x="2" y="1" width="54" height="53" fill="#FFE9E6" />
        <rect x="2.5" y="1.5" width="53" height="52" stroke="#E3DEFF" />
        <path
          d="M23 21.5V33.3C23 34.4201 23 34.9798 23.218 35.4076C23.4097 35.7839 23.7155 36.0905 24.0918 36.2822C24.5192 36.5 25.079 36.5 26.1969 36.5H31.8031C32.921 36.5 33.48 36.5 33.9074 36.2822C34.2837 36.0905 34.5905 35.7839 34.7822 35.4076C35 34.9802 35 34.421 35 33.3031V21.5M23 21.5H25M23 21.5H21M25 21.5H33M25 21.5C25 20.5681 25 20.1024 25.1522 19.7349C25.3552 19.2448 25.7443 18.8552 26.2344 18.6522C26.6019 18.5 27.0681 18.5 28 18.5H30C30.9319 18.5 31.3978 18.5 31.7654 18.6522C32.2554 18.8552 32.6447 19.2448 32.8477 19.7349C32.9999 20.1024 33 20.5681 33 21.5M33 21.5H35M35 21.5H37"
          stroke="#E35E50"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_10020"
          x="0"
          y="0"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_10020"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_10020"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default DeleteBin
